<div class="d-none d-lg-flex banner">
  <h1>{{ 'payment.page.title' | translate }}</h1>
</div>

<fgb-page-header [pageTitle]="'payment.page.title'" [backButtonLink]="'/'" />

<div class="d-block d-lg-none">
  <fgb-payment-nav/>
</div>

<div class="container d-none d-lg-block">
  <fgbcl-ecash-description></fgbcl-ecash-description>
  <fgbcl-card-token-list
    [regex]="regex"
    [provider]="provider"
    [redirectUrl]="'/cardtoken/result'"
    [failureUrl]="'/cardtoken/failure'"
  ></fgbcl-card-token-list>
</div>

<div class="container d-block d-lg-none">
  <fgbcl-card-token-list
    [regex]="regex"
    [provider]="provider"
    [redirectUrl]="'/cardtoken/result'"
    [failureUrl]="'/cardtoken/failure'"
  ></fgbcl-card-token-list>
  <hr class="horizontal-line w-100" />
  <fgbcl-ecash-description></fgbcl-ecash-description>
</div>

<div class="container d-none d-lg-block mt-4">
  <hr class="horizontal-line" />
  <fgb-transaction-history
    [transactionTypes]="[transactionTypes.ecash, transactionTypes.payment]"
    [ecashView]="true"
  ></fgb-transaction-history>
</div>
